import { Link, useNavigate } from "react-router-dom";
import { Trash2, Minus, Plus } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { formatPrice, img } from "@/lib/api";
import { FREE_SHIPPING_THRESHOLD, STANDARD_SHIPPING_COST } from "@/lib/constants";
import { Button } from "@/components/ui/button";

export default function CartPage() {
  const { cart, updateQty, removeFromCart, cartTotal } = useStore();
  const nav = useNavigate();
  const shipping = cartTotal >= FREE_SHIPPING_THRESHOLD ? 0 : STANDARD_SHIPPING_COST;

  if (!cart.length) return (
    <div className="mx-auto max-w-2xl px-6 py-24 text-center">
      <h1 className="font-display text-4xl">Your Bag is Empty</h1>
      <p className="text-muted-foreground mt-3">Discover something you'll love.</p>
      <Link to="/shop"><Button className="mt-8 rounded-none bg-[#D4AF37] text-black">Start Shopping</Button></Link>
    </div>
  );

  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 py-12">
      <h1 className="font-display text-4xl mb-10">Shopping Bag</h1>
      <div className="grid lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2 divide-y divide-border">
          {cart.map((i) => (
            <div key={i.id} className="flex gap-5 py-6" data-testid={`cart-page-item-${i.id}`}>
              <Link to={`/product/${i.slug}`}><img src={img(i.image)} alt={i.name} className="h-32 w-24 object-cover bg-[#F5F1E8]" /></Link>
              <div className="flex-1">
                <Link to={`/product/${i.slug}`}><h3 className="font-display text-xl hover:text-[#D4AF37]">{i.name}</h3></Link>
                <p className="text-muted-foreground mt-1">{formatPrice(i.price)}</p>
                <div className="flex items-center gap-4 mt-4">
                  <div className="flex items-center border border-border">
                    <button className="px-3 py-2" onClick={() => updateQty(i.id, i.quantity - 1)}><Minus className="h-3.5 w-3.5" /></button>
                    <span className="px-3 text-sm">{i.quantity}</span>
                    <button className="px-3 py-2" onClick={() => updateQty(i.id, i.quantity + 1)}><Plus className="h-3.5 w-3.5" /></button>
                  </div>
                  <button onClick={() => removeFromCart(i.id)} className="text-muted-foreground hover:text-destructive"><Trash2 className="h-4 w-4" /></button>
                </div>
              </div>
              <span className="font-medium">{formatPrice(i.price * i.quantity)}</span>
            </div>
          ))}
        </div>
        <div className="bg-[#F5F1E8] dark:bg-[#141414] p-6 h-fit">
          <h2 className="font-display text-2xl mb-5">Summary</h2>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between"><span>Subtotal</span><span>{formatPrice(cartTotal)}</span></div>
            <div className="flex justify-between"><span>Shipping</span><span>{shipping === 0 ? "Free" : formatPrice(shipping)}</span></div>
            <div className="flex justify-between font-display text-xl pt-3 border-t border-border"><span>Total</span><span>{formatPrice(cartTotal + shipping)}</span></div>
          </div>
          <Button onClick={() => nav("/checkout")} data-testid="cart-page-checkout" className="w-full rounded-none mt-6 h-12 bg-[#D4AF37] text-black font-semibold hover:brightness-110">Checkout</Button>
        </div>
      </div>
    </div>
  );
}
